import { Component, OnInit } from '@angular/core';
import { RouteService } from 'src/app/Services/route.service';
import * as Highcharts from 'src/assets/js/highcharts';
declare var google: any;
import { Output, EventEmitter } from '@angular/core';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'app-roster-dashboard',
  templateUrl: './roster-dashboard.component.html',
  styleUrls: ['./roster-dashboard.component.css']
})
export class RosterDashboardComponent implements OnInit {
  @Output() newItemEvent = new EventEmitter<string>();
  public disableGoback:any=true;
  public userRestrictionData:any={};
  public headers:any=[];
  public subModuleHeaders:any=[];
  constructor(
    private routeservice: RouteService,
    public storage: StorageService,
  ) {
    let user = this.storage.get('userInfo');
    if(user && user['fieldMap']){
      this.userRestrictionData=user['fieldMap'];
    }
  }

  ngOnInit(): void {
    if(this.userRestrictionData['Dashboard'].menu1['Roster'].menu2){
      let keys=Object.keys(this.userRestrictionData['Dashboard'].menu1['Roster'].menu2);
      for(let i=0;i<keys.length;i++){
        if(this.userRestrictionData['Dashboard'].menu1['Roster'].menu2[keys[i]].checked || this.userRestrictionData['Dashboard'].menu1['Roster'].menu2[keys[i]].indeterminate){
          this.headers.push(keys[i]);
        }
      }
    }
    if(this.userRestrictionData['Dashboard'].menu1['Roster'].menu2['Reports'].menu3){
      let subKeys=Object.keys(this.userRestrictionData['Dashboard'].menu1['Roster'].menu2['Reports'].menu3);
      for(let i=0;i<subKeys.length;i++){
        if(this.userRestrictionData['Dashboard'].menu1['Roster'].menu2['Reports'].menu3[subKeys[i]].checked || this.userRestrictionData['Dashboard'].menu1['Roster'].menu2['Reports'].menu3[subKeys[i]].indeterminate){
          this.subModuleHeaders.push(subKeys[i]);
        }
      }
    }
  }
  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }
}
